module.exports = __webpack_public_path__ + "img/background.c7f6ab8f.png";